
<template>
  <el-dialog
    :title="title"
    :visible.sync="visible"
    width="600px"
    @close="handleClose">
    <el-form ref="form" :model="form" label-width="140px" :rules="rules">
      <el-form-item label="政策名称" prop="name">
        <el-input v-model="form.name" :disabled="change" placeholder="请输入政策名称"></el-input>
      </el-form-item>
      <el-form-item label="级别" prop="level">
        <el-radio v-model="form.level" :label="1">一级</el-radio>
        <el-radio v-model="form.level" :label="2">二级</el-radio>
      </el-form-item>
      <el-form-item label="上级分类" prop="parentId" v-if="form.level==2"
                    :rules="[{ required: true, message: '请选择上级分类' }]">
        <el-select v-model="form.parentId" placeholder="请选择">
          <el-option
            v-for="item in policyOptions"
            :key="item.value"
            :label="item.label"
            :value="item.value">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="体系名称" prop="systemName" v-if="form.level==2"
                    :rules="[{ required: true, message: '请选择体系名称' }]">
        <el-select v-model="form.systemName" placeholder="请选择体系名称">
          <el-option
            v-for="item in systemOptions"
            :key="item.value"
            :label="item.label"
            :value="item.value">
          </el-option>
        </el-select>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="visible = false">取 消</el-button>
      <el-button type="primary" @click="handleSubmit">保 存</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { mapActions } from 'vuex'
export default {
  name: 'addOrEditDialog',
  props: ['show', 'info'],
  data () {
    return {
      visible: this.show,
      form: {},
      rules: {
        name: [{ required: true, message: '政策名称不能为空' }]
      },
      policyOptions: [],
      systemOptions: [],
      baseForm: {
        id: undefined,
        name: '',
        level: 1,
        parentId: 0,
        systemName: '',
        status: 1
      }
    }
  },
  computed: {
    title () {
      return this.isEdit ? '编辑政策' : '新增政策'
    },
    isEdit () {
      return !this.$lodash.isEmpty(this.info)
    }
  },
  methods: {
    ...mapActions(['queryPolicyList', 'updatePolicyInfo', 'deletePolicyInfo', 'queryPolicyListNew', 'querySystemOptionsInfo']),
    // 关闭弹出层
    handleClose () {
      this.$emit('update:show', false)
    },
    // 提交
    handleSubmit () {
      this.$refs.form.validate(val => {
        if (val) {
          let params = {
            ...this.form
          }
          if (params.level === 1) {
            params.parentId = 0
            params.systemName = '' // 一级政策清空体系名称
          }
          this.updatePolicyInfo(params).then(() => {
            this.visible = false
            this.queryPolicyListNew()
          })
        } else {
          return false
        }
      })
    },
    // 政策一级
    getPolicyList () {
      this.queryPolicyList().then(res => {
        this.policyOptions = res.map(item => ({
          value: item.id,
          label: item.name
        }))
      })
    },
    // 获取体系名称列表
    getSystemOptions () {
      this.querySystemOptionsInfo({ status: 0 }).then(res => {
        if (Array.isArray(res) && res.length) {
          this.systemOptions = res.map(item => ({
            value: item,
            label: item
          }))
        }
      })
    }
  },
  watch: {
    show (newVal) {
      this.visible = newVal
      // 显示dialog时给form赋初始值
      if (newVal) {
        // 打开时更新模板数组
        this.getPolicyList()
        this.getSystemOptions()
        if (this.$lodash.isEmpty(this.info)) {
          this.form = {
            name: '',
            level: 1,
            parentId: '',
            systemName: '',
            status: 1
          }
        } else {
          this.form = {
            id: this.info.id,
            name: this.info.name,
            level: this.info.parentId ? 2 : 1,
            parentId: this.info.parentId,
            systemName: this.info.systemName || '',
            status: 1
          }
        }
        this.$nextTick(() => {
          this.$refs['form'].clearValidate()
        })
      }
    }
  },
  mounted () {
    this.getPolicyList()
    this.getSystemOptions()
  }
}
</script>

<style lang="scss" scoped>
.el-input, /deep/ .el-select, .el-input-number {
  width: 200px;
}
.height-over-scroll{
  max-height: 400px;
  overflow-y: scroll;
}
.height-over-scroll::-webkit-scrollbar {
  display: none;
}
.el-card {
  width: 680px;

  p {
    &:not(:last-child) {
      margin-bottom: 10px;
    }

    .input-discount {
      width: 110px;
    }

    span {
      display: inline-block;
      margin: 0 10px;
    }
  }
}

.inline-block {
  display: inline-block;
}

/deep/ .region-tree {
  height: 500px;
  overflow: auto;
}
/deep/ .industry-tree{
  min-height: 160px;
  max-height: 500px;
  overflow: auto;
}
</style>
